import { render, staticRenderFns } from "./ErrorNoData.vue?vue&type=template&id=24ebf40a&scoped=true&"
import script from "./ErrorNoData.vue?vue&type=script&lang=js&"
export * from "./ErrorNoData.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNoData.vue?vue&type=style&index=0&id=24ebf40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebf40a",
  null
  
)

export default component.exports